import ACTIONS from '@/store/storeActions';
import { v4 as uuid } from 'uuid';

class BusinessLogicExercise {
  constructor(vue) {
    this.vue = vue;
    this.$store = this.vue.$store;
    this.state = this.$store.state;
  }

  getExerciseOpenStatus(exerciseId) {
    return this.vue.$store.getters.isExerciseBlocked(exerciseId) ? 'red lighten-1' : 'green lighten-1';
  }

  addNewNote(penInkFormat) {
    const exerciseId = this.state.run.currentExerciseId;
    let allNotes = this.state.notes.notes.filter( (note) => note !== null && note.exerciseId === exerciseId);
    let page = 0;
    for (const i in allNotes) {
      if (i && allNotes[i]) {
        const note = allNotes[i];
        if (note.page > page) {
          page = note.page
        }
      }
    }
    page++;
    const newNote = this.createDefaultNote(this.state.run.currentExerciseId, page, penInkFormat);
    this.$store.dispatch(ACTIONS.ADD_NOTE, newNote);
    return newNote
  }

  deleteNote(note) {
    this.$store.dispatch(ACTIONS.REMOVE_NOTE, note);
  }

  createDefaultNote(exerciseId, page, penInkFormat = 'html') {
    let result = {
      exerciseId,
      name: `${this.vue.$i18n.t('NotesPage.newTitle')} ${page}`,
      page,
      penInkFormat,
      html: '',
      modified: true,
      id: uuid()
    }
    return result;
  }
}

export default BusinessLogicExercise;
